export default "__VITE_ASSET__B7_a6J$Z__"